import * as React from 'react';
import { usePHSPACCResultsResult } from '@components/phs/pacc/results/query/useResults';
import TestSummary from '@components/phs/pacc/results/result/applyResult/applyResultContent/testSummary';
import V4Guide from '@components/phs/pacc/results/result/applyResult/applyResultContent/v4Guide';
import GameGuide from '@components/phs/pacc/results/result/applyResult/applyResultContent/gameGuide';
import CopyrightWarning from '@components/phs/pacc/results/result/applyResult/applyResultContent/copyrightWarning';
import TestTip from '@components/phs/pacc/results/result/applyResult/applyResultContent/testTip';
import SrGuide from './srGuide';

interface ApplyResultContentProps {
  sn: number;
}

const ApplyResultContent = ({ sn }: ApplyResultContentProps) => {
  const { data: applyResult } = usePHSPACCResultsResult(sn);

  if (!applyResult) return null;

  return (
    <>
      {/* [D] 응시 결과 요약 영역 */}
      <TestSummary applyResult={applyResult} />

      {/* [D] 성향 파악 응시 결과 영역 */}
      <SrGuide sn={sn} applyResult={applyResult} />

      {/* [D] 영상 면접 응시 결과 영역 */}
      <V4Guide sn={sn} applyResult={applyResult} />

      {/* [D] 전략 게임 응시 결과 영역 */}
      <GameGuide sn={sn} applyResult={applyResult} />

      {/* [D] 맟춤형 꿀팁 영역 */}
      <TestTip sn={sn} applyResult={applyResult} />

      {/* [D] 경고 영역 */}
      <CopyrightWarning />
    </>
  );
};

export default ApplyResultContent;
